module.exports = __webpack_public_path__ + "static/media/delete.fdffca99.svg";